module.exports = __webpack_public_path__ + "static/logo-daaee55420f51b416f5556027f4d2764.png";